import { State } from './State';
export class WorkToken {
    constructor() {
        this._completed = new State(false); // BehaviorSubject
        this._cancelled = new State(false); // BehaviorSubject
    }
    get completed() {
        return {
            subscribe: (next) => {
                const id = this._completed.subscribe(prevValue => {
                    next(this._completed.value);
                });
                return {
                    unsubscribe: () => {
                        this._completed.unsubscribe(id);
                    },
                };
            },
        };
    }
    get cancelled() {
        return {
            subscribe: (next) => {
                const id = this._cancelled.subscribe(prevValue => {
                    next(this._cancelled.value);
                });
                return {
                    unsubscribe: () => {
                        this._cancelled.unsubscribe(id);
                    },
                };
            },
        };
    }
    get isCompleted() {
        return this._completed.value;
    }
    get isCancelled() {
        return this._cancelled.value;
    }
    complete() {
        if (this._completed.value)
            return;
        this._completed.update(true);
    }
}
export class WorkTokenSource extends WorkToken {
    cancel() {
        if (this._cancelled.value)
            return;
        this._cancelled.update(true);
    }
}
